import React from 'react';
import './CustomerDetailsModal.css';

const CustomerDetailsModal = ({ customer, onClose }) => {
  if (!customer) return null;

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getBadgeColor = (badge) => {
    switch (badge) {
      case 'Premium':
        return '#F7B801';
      case 'Regular':
        return '#004E89';
      case 'New':
        return '#2D6A4F';
      default:
        return '#6C757D';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const favoriteItems = [
    { name: 'Chicken Biryani', image: null, orderCount: 8 },
    { name: 'Beef Burger', image: null, orderCount: 5 },
    { name: 'Mango Lassi', image: null, orderCount: 3 }
  ];

  const savedAddresses = [
    { type: 'Home', address: '123 Main Street, Block A, Lahore, Pakistan' },
    { type: 'Office', address: '456 Business Plaza, Floor 3, Karachi, Pakistan' }
  ];

  const recentOrders = [
    { id: '#12345', items: 3, amount: 1250, date: '2024-12-10', status: 'Delivered' },
    { id: '#12344', items: 2, amount: 850, date: '2024-12-08', status: 'Delivered' },
    { id: '#12343', items: 5, amount: 2100, date: '2024-12-05', status: 'Delivered' }
  ];

  const memberSince = formatDate('2024-12-01');

  return (
    <div className="customer-details-overlay" onClick={onClose}>
      <div className="customer-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="header-content">
            {customer.profilePhoto ? (
              <img
                src={customer.profilePhoto}
                alt={customer.name}
                className="customer-photo-large"
              />
            ) : (
              <div
                className="customer-photo-large initials"
                style={{ backgroundColor: getBadgeColor(customer.badge) + '20' }}
              >
                <span style={{ color: getBadgeColor(customer.badge), fontSize: '32px' }}>
                  {getInitials(customer.name)}
                </span>
              </div>
            )}
            <div className="customer-header-info">
              <h2 className="customer-name-large">{customer.name}</h2>
              <div
                className="customer-badge-large"
                style={{ backgroundColor: getBadgeColor(customer.badge) }}
              >
                {customer.badge} Customer
              </div>
              <div className="member-since">Member since {memberSince}</div>
            </div>
          </div>
          <button className="modal-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-content">
          {/* Contact Information */}
          <div className="info-card">
            <h3 className="section-label">CONTACT INFORMATION</h3>
            <div className="contact-details">
              <a href={`tel:${customer.phone}`} className="contact-item">
                <span className="contact-icon">📞</span>
                <span>{customer.phone}</span>
              </a>
              <a href={`mailto:${customer.email}`} className="contact-item">
                <span className="contact-icon">📧</span>
                <span>{customer.email}</span>
              </a>
            </div>
          </div>

          {/* Statistics */}
          <div className="stats-section">
            <h3 className="section-label">CUSTOMER STATISTICS</h3>
            <div className="stats-grid">
              <div className="stat-box">
                <div className="stat-number-large">{customer.totalOrders}</div>
                <div className="stat-label-large">Total Orders</div>
              </div>
              <div className="stat-box">
                <div className="stat-number-large">PKR {customer.totalSpent.toLocaleString()}</div>
                <div className="stat-label-large">Total Spent</div>
              </div>
              <div className="stat-box">
                <div className="stat-number-large">PKR {customer.averageOrder.toLocaleString()}</div>
                <div className="stat-label-large">Average Order</div>
              </div>
              <div className="stat-box">
                <div className="stat-number-large">{formatDate(customer.lastOrderDate).split(',')[0]}</div>
                <div className="stat-label-large">Last Order</div>
              </div>
            </div>
          </div>

          {/* Favorite Items */}
          <div className="favorite-items-section">
            <h3 className="section-label">FAVORITE ITEMS</h3>
            <div className="favorite-items-list">
              {favoriteItems.map((item, index) => (
                <div key={index} className="favorite-item">
                  <div className="favorite-item-image">
                    {item.image ? (
                      <img src={item.image} alt={item.name} />
                    ) : (
                      <span>🍽️</span>
                    )}
                  </div>
                  <div className="favorite-item-info">
                    <div className="favorite-item-name">{item.name}</div>
                    <div className="favorite-item-count">Ordered {item.orderCount} times</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Saved Addresses */}
          <div className="addresses-section">
            <h3 className="section-label">SAVED ADDRESSES</h3>
            <div className="addresses-list">
              {savedAddresses.map((addr, index) => (
                <div key={index} className="address-card">
                  <span className="address-icon">{addr.type === 'Home' ? '🏠' : '💼'}</span>
                  <div className="address-info">
                    <div className="address-label">{addr.type}</div>
                    <div className="address-text">{addr.address}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Orders */}
          <div className="recent-orders-section">
            <h3 className="section-label">RECENT ORDERS</h3>
            <div className="orders-list">
              {recentOrders.map((order, index) => (
                <div key={index} className="order-item">
                  <div className="order-id">{order.id}</div>
                  <div className="order-details">
                    <span>{order.items} items</span>
                    <span>•</span>
                    <span>PKR {order.amount.toLocaleString()}</span>
                    <span>•</span>
                    <span>{formatDate(order.date)}</span>
                  </div>
                  <div className={`order-status ${order.status.toLowerCase()}`}>
                    {order.status}
                  </div>
                </div>
              ))}
            </div>
            <a href="#" className="view-all-link">View All Orders →</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetailsModal;

